import { multiSelectorOptionsMapper, optionsMapper } from '../utils';

const options = [
  { label: 'Até USD 10.000,00', value: '0:10000' },
  { label: 'De USD 10.000,01 à USD 50.000,00', value: '10000.01:50000' },
  { label: 'De USD 50.000,01 à USD 100.000,00', value: '50000.01:100000' },
  { label: 'Acima de USD 100.000,01', value: '100000.01:INFINITE' },
];

export const useBlockedProductValueRangeOptions = () => {
  return {
    singleSelectOptions: options.map(optionsMapper),
    multiSelectOptions: options.map(multiSelectorOptionsMapper),
  }
}